'use strict';

exports.__esModule = true;
exports.profileRightSection = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _profileRightSection = require('../actions/profile-right-section');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	scrollEnabled: true
};

var profileRightSection = exports.profileRightSection = function profileRightSection(state, action) {
	switch (action.type) {
		case _profileRightSection.SET_ACTIVE_SECTION:
			return (0, _assign2.default)({}, state, {
				activeHeader: action.section
			});
		case _profileRightSection.DISABLE_SCROLL_HIGHLIGHT:
			return (0, _assign2.default)({}, state, {
				scrollEnabled: false
			});
		case _profileRightSection.ENABLE_SCROLL_HIGHLIGHT:
			return (0, _assign2.default)({}, state, {
				scrollEnabled: true
			});
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/practice-page/lib/reducers/profile-right-section.js